import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, LocPortal, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'ECommerce|Store';
const sharedProps = {
	htmlAllowed: false,
	shared: false,
	portal: 'CP' as LocPortal,
	feature: HubFeature.Ecommerce,
};

export type EcommerceStoreLoc =
	| 'CPECommerceStoreTitle'
	| 'CPECommerceStorePageDescription'
	| 'CPECommerceStoreNameLabel'
	| 'CPECommerceStoreCodeLabel'
	| 'CPECommerceStoreTypeLabel'
	| 'CPECommerceStorePriceLabel'
	| 'CPECommerceStorePurchaseButton';

export const cpEcommerceStoreLocs: LocDefs<EcommerceStoreLoc> = {
	CPECommerceStoreTitle: {
		defaultValue: 'Store',
		displayType: 'Title',
		description: 'Title for the store page',
		displayPath: `${dpRoot}|Title`,
		...sharedProps,
	},
	CPECommerceStorePageDescription: {
		defaultValue: '',
		displayType: 'Content',
		description: 'Page description for the store page.',
		displayPath: `${dpRoot}|Page Description`,
		...sharedProps,
	},
	CPECommerceStoreNameLabel: {
		defaultValue: 'Name',
		displayType: 'Label',
		description: 'Label for the name field in the store page.',
		displayPath: `${dpRoot}|Name Label`,
		...sharedProps,
	},
	CPECommerceStoreCodeLabel: {
		defaultValue: 'Code',
		displayType: 'Label',
		description: 'Label for the code field in the store page.',
		displayPath: `${dpRoot}|Code Label`,
		...sharedProps,
	},
	CPECommerceStoreTypeLabel: {
		defaultValue: 'Type',
		displayType: 'Label',
		description: 'Label for the type field in the store page.',
		displayPath: `${dpRoot}|Type Label`,
		...sharedProps,
	},
	CPECommerceStorePriceLabel: {
		defaultValue: 'Price',
		displayType: 'Label',
		description: 'Label for the price field in the store page.',
		displayPath: `${dpRoot}|Price Label`,
		...sharedProps,
	},
	CPECommerceStorePurchaseButton: {
		defaultValue: 'Purchase',
		displayType: 'Button',
		description: 'Button for the purchase action in the store page.',
		displayPath: `${dpRoot}|Purchase Button`,
		...sharedProps,
	},
};

export const ecommerceStoreLocKeys = MapLocKeys<EcommerceStoreLoc>(cpEcommerceStoreLocs);
export type CpEcommerceStoreLocType = LocMap<EcommerceStoreLoc>;
